import { render, staticRenderFns } from "./createFeeTypes.vue?vue&type=template&id=8ff465e0"
import script from "./createFeeTypes.vue?vue&type=script&lang=js"
export * from "./createFeeTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports